import { convertDateToUnix } from '@diamond/shared/schema/sap';

export const toUnixTimestamp = (dateString: string, isEndOfDay = false) => {
  if (!dateString) return undefined;

  const baseDate = isEndOfDay
    ? `${dateString}T23:59:59Z`
    : `${dateString}T00:00:00Z`;

  return convertDateToUnix(new Date(baseDate), true);
};
